import Vue from 'vue';
import Component from 'vue-class-component';
import apiClient from '@/app/clients/api-client';

@Component({
  name: 'academy-mixin',
  components: {},
  props: []
})
export default class AcademyMixin extends Vue {
  isAcademyEnabled = false;
  private loaded = false;

  created() {
    this.academyStatus();
  }

  get workspace() {
    return this.$user.workspace;
  }

  get isAcademyEnabledForWorkspace() {
    if (!this.workspace) {
      return;
    }
    return (
      (this.workspace.configs && this.workspace.configs.academyEnabled) ||
      this.$user.eligible('academy')
    );
  }

  academyStatus() {
    apiClient
      .getAcademy()
      .then(response => {
        this.isAcademyEnabled = response?.enabled || false;
        this.loaded = true;
      })
      .catch(e => {
        this.$error(e);
        this.loaded = true;
      });
  }
}
